export const validateAuthor = (author: string): string => {
    let error = '';
    if (author.trim().length < 2) {
        error = 'لطفاً نام خود را کامل وارد کنید';
    }
    return error;
};

export const validateAuthorEmail = (authorEmail: string): string => {
    let error = '';
    const emailOrPhoneRegex =
        /(^[a-zA-Z0-9_.]+[@]{1}[a-z0-9]+[.][a-z]+$)|^(00989|\+989|09)(\d{9})$/;
    if (!emailOrPhoneRegex.test(authorEmail)) {
        error = 'لطفاً یک ایمیل یا شماره تلفن معتبر وارد کنید.';
    }
    return error;
};

export const validateContent = (content: string): string => {
    let error = '';
    if (content.trim().length < 2) {
        error = 'لطفاً نظر خود را کامل وارد کنید';
    }
    return error;
};
